import type { ATALineItem, Surcharge } from '../lib/api/types'

export const nettoBelop = (item: ATALineItem): number =>
  (item.mangd ?? 0) * (item.prisPerEnhet ?? 0)

export const bruttoBelop = (item: ATALineItem, surcharges: Surcharge[]): number => {
  const net = nettoBelop(item)
  if (!item.paslagKod) return net
  const s = surcharges.find((s) => s.sortOrder === item.paslagKod)
  return s ? net * (1 + s.procent) : net
}

export const ataNettoTotal = (lineItems: ATALineItem[], surcharges: Surcharge[]): number =>
  lineItems.reduce((sum, item) => sum + bruttoBelop(item, surcharges), 0)

export const momsBelopp = (nettoTotal: number, momsRate = 0.25): number =>
  nettoTotal * momsRate

export const summaMedMoms = (nettoTotal: number, momsRate = 0.25): number =>
  nettoTotal * (1 + momsRate)

/** Statuses whose ÄTA value counts as "upparbetat" (earned / work performed).
 *  godkand & fakturerad are built-in anchor ids that always exist. */
export const EARNED_STATUS_IDS = ['godkand', 'fakturerad']

export const isEarned = (status: string): boolean => EARNED_STATUS_IDS.includes(status)

/** Outstanding amount still to invoice on an ÄTA: current value − already invoiced.
 *  Recalculates from the live spec value, so an ÄTA expanded after invoicing
 *  (e.g. +50 000) shows the new remainder. Can be negative if over-invoiced. */
export const kvarAttFakturera = (
  belopp: number | null | undefined,
  faktureratBelopp: number | null | undefined,
): number => (belopp ?? 0) - (faktureratBelopp ?? 0)

export const formatPercent = (decimal: number | null | undefined): string =>
  decimal != null ? `${(decimal * 100).toFixed(2).replace(/\.?0+$/, '')} %` : '–'

export const formatSEK = (amount: number | null | undefined): string =>
  Math.round(amount ?? 0)
    .toLocaleString('sv-SE')
    .replace(/,/g, ' ') + ' kr'
